/* ew-acabados — 25-sep-2026, rehecho el 08-oct-2026.
   1. Algunas plantillas pintan dos veces el bloque `inventory_notice` (el panel PRO lo
      repite): se deja solo el primer «Personaliza este producto».
   2. El bloque se MUEVE a «Más información» (.section-complete-the-set .section__buttons),
      al final, debajo de los desplegables que ya baja ew-ficha.js y encima del panel
      profesional. Si la plantilla no tiene esa sección, se queda en la columna de compra.
   3. La línea «78 acabados a elegir →» se mete en la casilla MATERIAL de la cuadrícula de
      datos; al pulsarla se abre el desplegable y se baja hasta él. */
(function () {
  var moved = false;

  function once() {
    var all = document.querySelectorAll('[data-ew-acab]');
    for (var i = 1; i < all.length; i++) all[i].setAttribute('hidden', '');
    var fins = document.querySelectorAll('[data-ew-fin]');
    for (var f = 1; f < fins.length; f++) fins[f].setAttribute('hidden', '');
    var hints = document.querySelectorAll('[data-ew-acab-hint]');
    for (var j = 1; j < hints.length; j++) hints[j].parentNode && hints[j].parentNode.removeChild(hints[j]);
  }

  function place() {
    var acab = document.querySelector('[data-ew-acab]');
    if (!acab) return;
    var box = document.querySelector('.section-complete-the-set .section__buttons');
    if (box && !moved) {
      if (acab.parentNode !== box) box.appendChild(acab);
      acab.classList.add('ew-acab--more');
      moved = true;
    }
    var hint = document.querySelector('[data-ew-acab-hint]');
    if (hint && !hint.dataset.ewPlaced) {
      /* La casilla MATERIAL: por su etiqueta (es/en/nl/fr/pt), no por posición. */
      var cell = null, cells = document.querySelectorAll('.ew-kf2__cell');
      for (var c = 0; c < cells.length; c++) {
        var lab = cells[c].querySelector('.ew-keyfacts__lab');
        if (lab && /mat[eé]ria/i.test(lab.textContent)) { cell = cells[c]; break; }
      }
      if (!cell) { var mat = document.querySelector('[data-ew-kf-mat]'); cell = mat ? mat.closest('.ew-kf2__cell') : null; }
      if (!cell && cells.length > 1) cell = cells[1];
      if (cell) {
        cell.appendChild(hint);
        hint.removeAttribute('hidden');
        hint.dataset.ewPlaced = '1';
        hint.addEventListener('click', function (e) {
          e.preventDefault();
          acab.setAttribute('open', '');
          var y = acab.getBoundingClientRect().top + window.pageYOffset - 90;
          try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (err) { window.scrollTo(0, y); }
        });
      }
    }
  }

  /* 12-oct: la caja «Acabados» de la columna (.ew-fin) abre la carta completa y baja hasta ella. */
  function wireOpen() {
    var links = document.querySelectorAll('[data-ew-acab-open]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].dataset.ewWired) continue;
      links[i].dataset.ewWired = '1';
      links[i].addEventListener('click', function (e) {
        var acab = document.querySelector('[data-ew-acab]');
        if (!acab) return;
        e.preventDefault();
        acab.setAttribute('open', '');
        var y = acab.getBoundingClientRect().top + window.pageYOffset - 90;
        try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (err) { window.scrollTo(0, y); }
      });
    }
  }

  function run() {
    once();
    place();
    wireOpen();
    /* ew-ficha.js también mueve cosas al cargar: una segunda pasada por si llegó antes. */
    setTimeout(place, 150);
    setTimeout(place, 900);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', place);
})();
